export default function SubscriptionsHeader() {
    return (
        <div className="pt-4">
            <div className="flex justify-center items-center">
                <img src="/assets/pictures/new-label-yellow.png"/>
                <h1 class="font-dancingScript text-xl text-white pt-10 -ml-24">ABONNEMENTS</h1>
            </div>
            <div className="w-full">
                <h3 className="text-center text-lg text-white font-montserrat">Ne rate pas ta Star, prends vite ton abonnement !</h3>
            </div>
        </div>
    )
}
